module.exports = __webpack_public_path__ + "img/logo.7f0d72ae.webp";